import { combineReducers } from 'redux';
import { rememberReducer } from 'redux-remember';
import mainReducer from '../reducers/main.reducer';
import mainRememberReducer from '../reducers/main.remember.reducer';
import tradeReducer from '../reducers/trade.reducer';
import developersReducer from '../reducers/developers.reducer';
import followTradeReducer from '../reducers/follow.trade.reducer';

// Combine reducers
const reducers = {
    mainReducer,
    mainRememberReducer,
    tradeReducer,
    developersReducer,
    followTradeReducer,
};

// Remember only specified reducers
const rememberedKeys = ["mainRememberReducer"];

const rootReducer = rememberReducer(combineReducers(reducers));

export { rootReducer, rememberedKeys }; // Export both rootReducer and rememberedKeys